import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';

import { TranslateModule } from '@ngx-translate/core';

import { type BottomBarTab, BottomBarVisibilityService } from '@core/services/bottom-bar-visibility.service';
import { ThemeService } from '@core/services/theme.service';

import type { BottomBarTabConfig } from '@shared/layouts/bottom-bar/bottom-bar.types';
import { Dynamic } from '@shared/registry/dynamic';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.html',
  styleUrl: './bottom-bar.scss',
  imports: [IonTabs, IonTabBar, IonTabButton, TranslateModule, Dynamic],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomBar {
  private readonly themeService = inject(ThemeService);
  private readonly bottomBarVisibilityService = inject(BottomBarVisibilityService);

  protected readonly isTransition = signal(false);
  protected readonly showTabs = this.bottomBarVisibilityService.showTabs;

  protected readonly tabs = computed<BottomBarTab[]>(() => {
    const path = this.bottomBarVisibilityService.currentPath();
    const config = this.themeService.scaffold();
    if (!config?.tabs) return [];

    return config.tabs.map((tab: BottomBarTabConfig) => ({
      ...tab,
      isActive: path === `/${tab.route}` || path.startsWith(`/${tab.route}/`),
    }));
  });

  protected onTabChange(): void {
    this.isTransition.set(true);
  }

  protected onTabChanged(): void {
    setTimeout(() => {
      this.isTransition.set(false);
    }, 200);
  }
}
